import { render, staticRenderFns } from "./StudentDocumentsComponent.vue?vue&type=template&id=59e7ae24&scoped=true"
import script from "./StudentDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./StudentDocumentsComponent.vue?vue&type=script&lang=js"
import style0 from "./StudentDocumentsComponent.vue?vue&type=style&index=0&id=59e7ae24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e7ae24",
  null
  
)

export default component.exports